<template>
  <div>
    <b-breadcrumb
      :items="breadcrumb"
      style="margin-bottom: 0px;"
    ></b-breadcrumb>
    <b-img
      src="https://www.parmenia.com.ar/w/media/favslider/demo/foto1.jpg"
      fluid-grow
      alt="Fluid-grow image"
    ></b-img>
    <b-row class="mx-0">
      <b-col class="col-12 col-md-3" style="padding-top: 3rem;">
        <b-list-group flush style="font-family: 'Poppins', sans-serif;">
          <b-list-group-item href="#" class="d-flex" @click="setActiveView(0)">
            <div>Editorial y librería</div>
            <b-icon icon="chevron-right" class="ml-auto" />
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex" @click="setActiveView(2)">
            <div>Nuestros sellos</div>
            <b-icon icon="chevron-right" class="ml-auto" />
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col class="col-12 col-md-9">
        <transition name="fade">
          <div v-if="!hideList">
            <div v-if="activeView === 0">
              <main-title title="Editorial y Librería" />La Crujía nació a fines de la década del 70 
              como un proyecto de investigación interesado en estudiar distintas formas de comunicación 
              alternativa y popular. Su primera sede ubicada en San Martín se transformó en un lugar de 
              resistencia para pedagogos, catequistas y comunicadores durante la dictadura militar. 
              Con la llegada de la democracia, el equipo fundador buscó expandir su propuesta mediante 
              cursos y talleres de formación profesional, en un momento en el que en la Argentina aún no 
              había propuestas académicas dedicadas exclusivamente a la comunicación.<br/>
              Durante los años 80, con el traslado de los talleres a las calles Tucumán y 
              Ayacucho de la Ciudad de Buenos Aires, se inició un nuevo periodo de efervescencia. 
              Con la frase "Un lugar de encuentro" como motor de su propuesta, La Crujía se 
              convirtió rápidamente en un espacio inevitable a la hora de pensar la comunicación 
              tanto alternativa como masiva en nuestra región, encauzando las inquietudes de 
              periodistas, estudiantes, graduados y promotores culturales. Esto, sumado a los 
              cambios acelerados que la tecnología introdujo en el campo de la comunicación a 
              fines del siglo pasado, empujó a los creadores del proyecto a dar una serie de pasos 
              que hicieron más masiva su propuesta. Uno de ellos fue la apertura en 1987 de una 
              librería especializada, la cual se convirtió en una visita obligatoria para quienes 
              buscan material relacionado con el mundo comunicacional en América Latina. El local 
              se transformó en un punto de referencia para todos los interesados en textos de 
              ciencias sociales y humanísticas, ya que agrupa a las editoriales más prestigiosas 
              del campo. El otro paso consecuente fue la creación en 1999 del sello editorial 
              La Crujía, que rápidamente convocó a muchos de los autores más respetados del rubro. 
              Además de contar con títulos referidos a los medios tradicionales, La Crujía buscó 
              ampliar su propuesta con colecciones de comunicación política, marketing, gestión 
              organizacional, educación y plataformas digitales. La comunicación es un terreno 
              desafiante que presenta nuevas tendencias y búsquedas de forma constante, algo que 
              La Crujía siempre se encargó de reflejar en sus estanterías.<br/><br/>
              Actualmente ubicada en Viamonte 1984, la librería amplió sus campos de difusión 
              mediante una creciente actividad en las redes y un renovado sitio web. Detrás de 
              estos cambios la motivación sigue siendo contagiar la pasión por los libros, que 
              nunca dejan de ser el más sólido bálsamo de conocimiento en un mundo en constante 
              evolución.
            </div>
            <div v-if="activeView === 2">
              <main-title title="Nuestros sellos" />
              <b-row class="mx-0 pb-4 border-bottom">
                <!--
                <b-col class="col-12 col-md-4 text-center mb-4">
                  <b-img
                    src="https://www.parmenia.com.ar/w/images/home-menu-1-crujia.jpg"
                    fluid
                  ></b-img>
                </b-col>
                -->
                <b-col class="col-12 col-md-12 pl-2">
                  <div
                    style="font-family: 'Poppins', sans-serif; font-weight: bold; margin-bottom: .5rem;"
                  >
                    La Crujía
                  </div>
                  La Crujía es un punto de referencia inevitable en temas de
                  comunicación y periodismo dentro de América Latina. Sin
                  embargo pocos saben que, antes de ser un sello editorial, pasó
                  por varias etapas que reflejan su espíritu inquieto. Nacida a
                  fines de la década del 70’ como un centro de investigación
                  interesado en las distintas formas de comunicación alternativa
                  y popular, con la llegada de la democracia no dudó en
                  compartir su propuesta mediante cursos y talleres de formación
                  profesional. A esto sumó la apertura de una librería
                  especializada que es de visita obligatoria para quienes buscan
                  material relacionado con el mundo comunicacional. El año 1999
                  vio finalmente el nacimiento de Editorial La Crujía, sello que
                  reunió a un grupo de autores de gran prestigio académico para
                  crear un catálogo de consulta permanente entre estudiantes y
                  profesionales. Además de los textos referidos a los medios
                  tradicionales, sus colecciones sobre comunicación política,
                  marketing, gestión organizacional, educación y plataformas
                  digitales reflejaron los cambios acelerados que atraviesan el
                  mundo y la sociedad. Hoy La Crujía continúa su tradición de
                  búsqueda constante, generando contenidos de divulgación y
                  actualidad que la acercan a un público más amplio, pero con la
                  seriedad de siempre.
                </b-col>
              </b-row>
              <b-row class="mx-0 py-4 border-bottom">
                <!--
                <b-col class="col-12 col-md-4 text-center mb-4">
                  <b-img
                    src="https://www.parmenia.com.ar/w/images/home-menu-1-stella.jpg"
                    fluid
                  ></b-img>
                </b-col>
                -->
                <b-col class="col-12 col-md-12 pl-2">
                  <div
                    style="font-family: 'Poppins', sans-serif; font-weight: bold; margin-bottom: .5rem;"
                  >
                    Stella
                  </div>
                  La fundación de editorial Stella en el año 1941 fue fruto de
                  las inquietudes pedagógicas de un grupo de Hermanos de la
                  Comunidad La Salle. Interesados en reflejar sus experiencias
                  de enseñanza en distintas materias, idearon una serie de
                  manuales cuyos contenidos y modos de sistematización
                  demostraron un enorme poder de llegada, tanto entre docentes
                  como en alumnos. Rápidamente el emprendimiento trascendió la
                  esfera de su comunidad y durante las siguientes décadas los
                  textos, cuadernos y materiales de apoyo del sello fueron
                  adoptados por instituciones de todo el país. Por ello no es
                  exagerado decir que los libros escolares de Stella estuvieron
                  presentes en casi todos los hogares argentinos durante
                  generaciones. Hoy Stella continúa editando textos de
                  educación, tanto laicos como religiosos, con un perfil
                  creativo y riguroso. Su tarea se complementa con la
                  publicación de libros sobre pedagogía popular y educación
                  especial, fruto del trabajo exhaustivo de especialistas en
                  dichos campos. De esta manera, mientras la educación atraviesa
                  una etapa de profundos cambios, este sello histórico confirma
                  su vocación inclusiva y plural.
                </b-col>
              </b-row>
              <b-row class="mx-0 py-4">
                <!--
                <b-col class="col-12 col-md-4 text-center mb-4">
                  <b-img
                    src="https://www.parmenia.com.ar/w/images/home-menu-1-sendero.jpg"
                    fluid
                  ></b-img>
                </b-col>
                -->
                <b-col class="col-12 col-md-12 pl-2">
                  <div
                    style="font-family: 'Poppins', sans-serif; font-weight: bold; margin-bottom: .5rem;"
                  >
                    Sendero
                  </div>
                  Activo desde el año 2015, Sendero es un sello editorial joven
                  centrado en la publicación de títulos de educación pastoral
                  con una perspectiva contemporánea. Sus textos para la
                  enseñanza catequística brindan las herramientas necesarias
                  para que docentes y tutores puedan enseñar los valores
                  cristianos de una manera acorde a los tiempos que corren. De
                  esta forma los estudiantes se inician en el camino espiritual
                  con un mensaje humano, solidario y con el respeto mutuo como
                  base. Todas estas virtudes diferencian a Sendero de otros
                  sellos similares, dejando en claro su intención de ofrecer
                  publicaciones que propongan una espiritualidad más acorde a
                  este siglo cambiante.
                </b-col>
              </b-row>
            </div>
          </div>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import MainTitle from "@/components/MainTitle.vue";

export default {
  name: "Nosotros",
  components: {
    MainTitle
  },
  data: function() {
    return {
      breadcrumb: [
        {
          text: "Inicio",
          to: { name: "Home" }
        },
        {
          text: "Nosotros",
          active: true
        }
      ],
      activeView: 0,
      hideList: false
    };
  },
  methods: {
    setActiveView(view) {
      this.hideList = true;
      this.activeView = view;
      setTimeout(
        function() {
          this.hideList = false;
        }.bind(this),
        500
      );
    }
  }
};
</script>
